import gql from 'graphql-tag';

const GSS_CLASSROOM_SETTINGS_FRAGMENT = gql`
  fragment BaseGssClassroomSettings on GssClassroomSettings {
    locale
    handedness {
      leftHanded
      rtlCrossStroke
    }
    characterOrder {
      letters
      numbers
      wdtNumbers
      wdtLowercase
      wdtCapitals
    }
  }
`;

export default GSS_CLASSROOM_SETTINGS_FRAGMENT;
